import type { TOC } from '@ember/component/template-only';
export interface TasLimitsSummaryLineItemSig {
  Args: {
    label?: string;
    labelClass: string;
    value?: string | number | null | undefined;
    valueClass: string;
    isLoading?: boolean;
    sign?: 'plus' | 'minus';
  };
  Blocks: {
    default: [];
  };
}

const TasLimitsSummaryLineItem: TOC<TasLimitsSummaryLineItemSig> = <template>
  <dt class={{@labelClass}}>
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{@label}}:
    {{/if}}
  </dt>
  <dd class="font-semibold text-right {{@valueClass}}">
    {{#if @isLoading}}
      <div class="p-2 animate-pulse">
        <div class="h-4 tio-bg-skeleton rounded-full"></div>
      </div>
    {{else}}
      {{#if @sign}}
        {{#if (eq @value "$0.00")}}
          {{@value}}
        {{else if (eq @sign "plus")}}
          +{{@value}}
        {{else if (eq @sign "minus")}}
          -{{@value}}
        {{/if}}
      {{else}}
        {{@value}}
      {{/if}}
    {{/if}}
  </dd>
</template>;

export default TasLimitsSummaryLineItem;
